import HOC from '../HOC';
import {polygon} from '../utility';

let Gaming = () => {return null;}

export default HOC(Gaming, polygon);



// WEBPACK FOOTER //
// ./src/components/News/Gaming.js